import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2751">
      <div className="dark" data-id="element-2752">
        <Hero data-id="element-2753" />
      </div>
      <WhyUs data-id="element-2754" />
      <ByTheNumbers data-id="element-2755" />
      <Services data-id="element-2756" />
      <HowItWorks data-id="element-2757" />
      <FAQ data-id="element-2758" />
      <Reviews data-id="element-2759" />
      <CtaBanner data-id="element-2760" />
    </main>;
}